var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Forward only Datacap's four-digit metadata, never a full or masked account.
export var getRecaptchaCardLastFour = function (value) {
    if (typeof value !== "string" || value.length !== 4) {
        return undefined;
    }
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var digit = value_1[_i];
        if (digit < "0" || digit > "9") {
            return undefined;
        }
    }
    return value;
};
var verificationMessage = "We could not verify your payment. Please try again.";
var scriptLoading = null;
// Public settings are available before processor initialization, including the
// Vantiv form that can submit a sale from inside the hosted iframe.
export var withPaymentBotToken = function (payload_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([payload_1], args_1, true), Promise, function (payload, initialization) {
        var session, _a;
        var _b;
        if (initialization === void 0) { initialization = false; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    session = window.session;
                    if ((initialization && (session === null || session === void 0 ? void 0 : session.recaptcha_initialization_required) !== true) || !(session === null || session === void 0 ? void 0 : session.recaptcha)) {
                        // Old page bootstrap data can omit settings. The backend still enforces
                        // verification; observation-only locations must be allowed to continue.
                        return [2 /*return*/, payload];
                    }
                    _a = [__assign({}, payload)];
                    _b = {};
                    return [4 /*yield*/, getRecaptchaToken(session.recaptcha)];
                case 1: return [2 /*return*/, __assign.apply(void 0, _a.concat([(_b.recaptcha_token = _c.sent(), _b)]))];
            }
        });
    });
};
var loadRecaptcha = function (siteKey) {
    var _a;
    if ((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise) {
        return Promise.resolve();
    }
    if (scriptLoading) {
        return scriptLoading;
    }
    scriptLoading = new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src^="https://www.google.com/recaptcha/enterprise.js"]');
        var script = existing !== null && existing !== void 0 ? existing : document.createElement("script");
        var cleanup = function () {
            window.clearTimeout(timeout);
            script.removeEventListener("load", loaded);
            script.removeEventListener("error", failed);
        };
        var failed = function () {
            cleanup();
            if (!existing) {
                script.remove();
            }
            reject(new Error(verificationMessage));
        };
        var loaded = function () {
            var _a;
            if (!((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise)) {
                failed();
                return;
            }
            cleanup();
            resolve();
        };
        var timeout = window.setTimeout(failed, 10000);
        script.addEventListener("load", loaded);
        script.addEventListener("error", failed);
        if (!existing) {
            script.id = "arrowpay-recaptcha-sdk";
            script.src = "https://www.google.com/recaptcha/enterprise.js?render=".concat(encodeURIComponent(siteKey));
            script.async = true;
            document.head.appendChild(script);
        }
    }).catch(function (error) {
        scriptLoading = null;
        throw error;
    });
    return scriptLoading;
};
// Called once per payment submission. Tokens are never cached or retried.
export var getRecaptchaToken = function (settings) { return __awaiter(void 0, void 0, Promise, function () {
    var siteKey_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (!settings || typeof settings.enabled !== "boolean") {
                    throw new Error(verificationMessage);
                }
                if (!settings.site_key && !settings.enabled) {
                    return [2 /*return*/, undefined];
                }
                if (typeof settings.site_key !== "string" || settings.site_key.trim() === ""
                    || settings.action !== "checkout_payment") {
                    throw new Error(verificationMessage);
                }
                siteKey_1 = settings.site_key;
                return [4 /*yield*/, loadRecaptcha(siteKey_1)];
            case 1:
                _a.sent();
                return [4 /*yield*/, new Promise(function (resolve, reject) {
                        var _a;
                        var timeout = window.setTimeout(function () { return reject(new Error(verificationMessage)); }, 10000);
                        var fail = function () {
                            window.clearTimeout(timeout);
                            reject(new Error(verificationMessage));
                        };
                        try {
                            var enterprise_1 = (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise;
                            if (!enterprise_1) {
                                fail();
                                return;
                            }
                            enterprise_1.ready(function () {
                                try {
                                    enterprise_1.execute(siteKey_1, { action: settings.action }).then(function (token) {
                                        window.clearTimeout(timeout);
                                        if (typeof token !== "string" || token.trim() === "") {
                                            fail();
                                            return;
                                        }
                                        resolve(token);
                                    }, fail);
                                }
                                catch (error) {
                                    fail();
                                }
                            });
                        }
                        catch (error) {
                            fail();
                        }
                    })];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                if ((settings === null || settings === void 0 ? void 0 : settings.enabled) !== false) {
                    // Match the existing ArrowPay error normalizer.
                    throw { Message: verificationMessage };
                }
                // Observation failures must not block checkout. The server records the
                // missing token and continues when this location's switch is off.
                return [2 /*return*/, undefined];
            case 4: return [2 /*return*/];
        }
    });
}); };
